export function separateWorkDateGroup(entries, entry, segment) {
  if (!segment || segment.component_type === "mixed" || String(segment.rate_code || "").toUpperCase() === "PTS" || Number(segment.claimed_driving_hours || 0) > 0) return null;
  const sequences = new Set((segment.entry_sequences || []).map(Number));
  const rows = entries.filter(row => sequences.has(Number(row.sequence)));
  const dateOf = row => row.source_date || row.date || "";
  if (new Set(rows.map(dateOf).filter(Boolean)).size < 2) return null;
  const date = dateOf(entry);
  if (!date) return null;
  const dailyRows = rows.filter(row => dateOf(row) === date);
  return {
    key: `segment-${segment.id ?? segment.sequence}-date-${date}`,
    isLead: Number(entry.sequence) === Math.min(...dailyRows.map(row => Number(row.sequence))),
  };
}
